import { render } from "./menu.vue?vue&type=template&id=43446c4d&scoped=true"
import script from "./menu.vue?vue&type=script&lang=js"
export * from "./menu.vue?vue&type=script&lang=js"

import "./menu.vue?vue&type=style&index=0&id=43446c4d&lang=scss&scoped=true"
import "./menu.vue?vue&type=style&index=1&id=43446c4d&lang=scss"
script.render = render
script.__scopeId = "data-v-43446c4d"

export default script